import { render, staticRenderFns } from "./update-payment-details.vue?vue&type=template&id=4b560cad&scoped=true"
import script from "./update-payment-details.vue?vue&type=script&lang=js"
export * from "./update-payment-details.vue?vue&type=script&lang=js"
import style0 from "./update-payment-details.vue?vue&type=style&index=0&id=4b560cad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b560cad",
  null
  
)

export default component.exports